/**
 * Class representing various window operations.
 */
export default class WindowHelper {

  /**
    * Gets the dimensions of the viewport.
    * @returns {Object} An object containing the width and height of the viewport.
    */
  getViewportDimensions = function () {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  /**
    * Copies the given text to the clipboard.
    * @param {string} text - The text to copy to the clipboard.
    */
  copyToClipboard(text: string): void {
      navigator.clipboard.writeText(text);
  }

  /**
    * Changes the CSS class of an element by its ID.
    * @param {string} id - The ID of the element.
    * @param {string} css - The new CSS class to apply.
    */
  changeCssById(id: string, css: string): void {
      const element: HTMLElement | null = document.getElementById(id);
      if (element) {
          element.className = css;
      }
  }

  /**
    * Updates a specific style property of an element by its ID.
    * @param {string} elementId - The ID of the element.
    * @param {string} propertyName - The name of the style property to update.
    * @param {string} value - The new value for the style property.
    */
  updateStyleProperty(elementId: string, propertyName: string, value: string): void {
      const element: HTMLElement | null = document.getElementById(elementId);
      if (element) {
          element.style.setProperty(propertyName, value);
      }
  }

  /**
    * Changes a global CSS variable.
    * @param {string} name - The name of the CSS variable.
    * @param {string} newValue - The new value for the CSS variable.
    */
  changeGlobalCssVariable(name: string, newValue: string): void {
      document.documentElement.style.setProperty(name, newValue);
  }

  /**
    * Opens a new window with the given arguments.
    * Needed as per https://stackoverflow.com/questions/62769031/how-can-i-open-a-new-window-without-using-js
    * @param {string} args - The arguments for the window.open function.
    */
  open(args: string): void {
      window.open(args);
  }
}
